var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSpotify(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 29,
    viewBox: "0 0 29 29",
    width: 29,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.4 0C6.447 0 0 6.447 0 14.4s6.447 14.4 14.4 14.4c7.954 0 14.4-6.447 14.4-14.4C28.8 6.448 22.355 0 14.4 0zm6.604 20.77a.897.897 0 01-1.235.297C16.39 19 12.133 18.534 7.12 19.678a.898.898 0 01-.399-1.75c5.486-1.254 10.19-.714 13.987 1.605.423.26.557.812.297 1.235zm1.763-3.922a1.123 1.123 0 01-1.544.37c-3.871-2.38-9.772-3.068-14.35-1.678a1.124 1.124 0 01-1.401-.748 1.124 1.124 0 01.749-1.4c5.23-1.587 11.73-.819 16.176 1.913.528.325.695 1.016.37 1.543zm.151-4.083C18.277 10.01 10.62 9.755 6.188 11.1a1.347 1.347 0 11-.781-2.578c5.086-1.544 13.542-1.246 18.886 1.927.641.38.85 1.206.47 1.845a1.346 1.346 0 01-1.844.471z",
    fill: "#fff"
  })));
}

export default SvgSpotify;